export const JINGGANGSHAN_BRAND_NAME =
  '井冈山国企Ai穿透式监管系统';

export const JINGGANGSHAN_SHORT_BRAND_NAME = '井冈山城控集团';

export const JINGGANGSHAN_PLATFORM_NAME = '井冈山国企Ai穿透式监管系统';

export const JINGGANGSHAN_THEME_STORAGE_KEY = 'jinggangshan-drp-ui-theme-v2';
